module.exports = __webpack_public_path__ + "img/pig_icon.9e869819.svg";